import { axiosAjax } from '@app/src/config/axios';
import { isClientEnv } from '@app/src/utils/validations';

export const leadService = {
  async post(json): Promise<any> {
    try {
      const { data } = await axiosAjax.post(process.env.API_OPPORTUNITY_LEAD, json);
      return data;
    } catch (e) {
      console.log(`Error post lead services: ${e}`);
      throw new Error(e);
    }
  },
  async postHome(json): Promise<any> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.post(process.env.API_HOME_LEAD, json, config);
      return data;
    } catch (e) {
      console.log(`Error postHome lead services: ${e}`);
      throw new Error(e);
    }
  }
};
